import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

const apiURL = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class BasketsService {

  private isLoadingSub = new Subject<boolean>();

  constructor(private http: HttpClient, private router: Router, private snackBar: MatSnackBar) { }

  getBaskets() {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/baskets/query`, {});
  }

  getBasketsAsAdmin() {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/baskets/query/admin`, {});
  }

  getBasketAsAdmin(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/baskets/query/admin`, data);
  }

  getIsloadingUpdated() {
    return this.isLoadingSub.asObservable();
  }

  createBasket(data) {
    this.http.post<{ success: boolean, data: any }>(`${apiURL}/baskets`, data).subscribe(result => {
      this.isLoadingSub.next(false);

      if (result.success) {

        this.router.navigate(['/admin/baskets']);

        this.snackBar.open('Basket successfully added', 'Dismiss', {
          duration: 3000
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    })
  }

  updateBasket(data) {
    return this.http.put<{ success: boolean, data: any }>(`${apiURL}/baskets`, data);
  }
}
